import { assert } from './assert.ts';

class InsufficientFunds extends Error {
  constructor(acct: Account, withdrawal_amt: number) {
    super(
      `Insuffient funds to withdraw ${withdrawal_amt} from ${acct.name}, `
      + `only ${acct.balance} remains.`,
    );
  }
}

export class Account {
  static deserialize(data: any): Account {
    // Defensive check in case a string sneaks in
    const j = typeof data === 'string' ? JSON.parse(data) : data;

    const name = j.name as string;
    const balance = j.balance as number;

    return balance >= 0
      ? new Account(name).credit(balance)
      : new Account(name).debit(-balance);
  }

  _name: string;
  _balance: number;

  constructor(name: string) {
    this._name = name;
    this._balance = 0;
  }

  serialize(): object {
    return {
      name: this.name,
      balance: this.balance,
    };
  }

  get name(): string {
    return this._name;
  }

  get balance(): number {
    return this._balance;
  }

  toString(): string {
    return `Account{${this._name}, ${this._balance}}`;
  }

  credit(amount: number): Account {
    assert(amount >= 0, 'amount should be positive');
    const a2 = new Account(this._name);
    a2._balance = this._balance + amount;
    return a2;
  }

  debit(amount: number): Account {
    assert(amount >= 0, 'amount should be positive');
    if (amount > this.balance) {
      throw new InsufficientFunds(this, amount);
    }

    const a2 = new Account(this._name);
    a2._balance = this._balance - amount;
    return a2;
  }
}
